<template>
  <div
    :id="`toast-${notification.id}`"
    class="notification pointer-events-auto max-w-sm shadow-2xl"
    :data-type="notification?.type"
    role="alert"
  >
    <div class="flex w-full items-start gap-2">
      <SvgIcon
        v-if="notification.type === 'danger' || notification.type === 'warning'"
        class="notification-icon"
        name="Error-Circle"
      ></SvgIcon>
      <SvgIcon
        v-else-if="notification.type === 'success'"
        class="notification-icon"
        name="Checkmark-Circle"
      ></SvgIcon>
      <div class="flex-1 text-base font-normal">
        {{ notification.message }}
      </div>

      <button
        class="notification-button -m-2 flex-shrink-0 p-2"
        :data-dismiss-target="`toast-${notification.id}`"
        aria-label="Close"
        @click="$emit('click:close', notification.id)"
      >
        <SvgIcon class="h-4 w-4" name="icon-menu-close"></SvgIcon>
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import type { Notification } from "@shopware-pwa/composables-next";
import SvgIcon from "~/templates/elements/SvgIcon.vue";

defineEmits<{
  (e: "click:close", id: number): void;
}>();

defineProps<{
  notification: Notification;
}>();
</script>
